module.exports = __webpack_public_path__ + "static/media/Laptop.2fffa483.png";